// src/firebase/erpFirebase.js
import { initializeApp, getApps, getApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const erpFirebaseConfig = {
  apiKey: "AIzaSyBXHy7dTTC29dzf6LAvI5y18V7AEe-F5OU",
  authDomain: "vj-invoice.firebaseapp.com",
  projectId: "vj-invoice",
  storageBucket: "vj-invoice.firebasestorage.app",
  messagingSenderId: "961146691784",
  appId: "1:961146691784:web:d8546eff9eb9494db0c5fd",
  measurementId: "G-H2CQMZ7YBK",
};

// Use a named app instance ("erpApp") to avoid conflicts with the primary DB
const erpApp = getApps().some((app) => app.name === "erpApp")
  ? getApp("erpApp")
  : initializeApp(erpFirebaseConfig, "erpApp");

export const erpDb = getFirestore(erpApp);
